import { useState, useEffect, useRef } from "react";
import styles from '../../candidateInfo.module.scss';
import stylesM from '../../../../components/modal/modal_base.module.scss';
import profileIcon from '../../../../../assets/icons/icon_photo.svg';
import pencilIcon from '../../../../../assets/icons/orange_pencil.svg';
import { InputText } from "../../../../components/inputs/InputText";
import Select from "../../../../components/inputs/Select";
import { selectEmtpy } from "../../../../core/hardcode";
import { QuantityRange } from "../../../../components/inputs/QuantityRange";
import { Seniority } from "../../../../components/inputs/Seniority";
import { TextArea } from "../../../../components/inputs/TextArea";
import { InputSelect } from "../../../../components/inputs/InputSelect";
import { validateIsAlphaWithoutSymbols, validatePhoneIsNumber } from "../../../../core/validators";
import { personalInfoFields } from "../../../../core/hardcode";

const PersonalInfo = ({
    personalInfo,
    onPersonalInfoChange,
    onPersonalInfoBlur,
    onPersonalInfoFileChange,
    personalInfoErrors,
    file,
    setFile,
    descriptionFocus,
    photoError,
    catSeniority,
    catSector,
    catCountries,
    catCurrencies
}) => {

    const hiddenFileInput = useRef(null);
    const textareaRef = useRef(null);
    const photoRef = useRef(null);
    const { currentSalary, currentCurrency, salaryMin, salaryMax, currency, image } = personalInfoFields;
    // const [optionsSelecteds, setOptionsSelecteds] = useState([]);

    const onChangeInput = (property, value) => {
        if (property === 'nss') {
            if ( value === '' || !validatePhoneIsNumber(value) ) {
                onPersonalInfoChange(property, value);
            }
        } else if (property === 'curp') {
            const curpInValid = validateIsAlphaWithoutSymbols(value);
            if ( value === '' || !curpInValid ) {
                onPersonalInfoChange(property, value.toUpperCase());
            }
        } else {
            onPersonalInfoChange(property, value);
        }
    }

    const onChangeSelect = (property, value) => {
        onPersonalInfoChange(property, value, {
            [`${property}Id`]: value.id,
            [`${property}Name`]: value.description
        });
        // if (property === 'profile' && value && value.id && value.id !== 0) {
        //     setOptionsSelecteds([value.id])
        // }
    }

    const onChangeInputSelect = (property, optionsSelecteds) => {
        onChangeInput(property, optionsSelecteds.map(({id}) => id));
    }

    const handleFileInputChange = ({ target }) => {
        const fileUploaded = target.files[0];
        onPersonalInfoFileChange(fileUploaded);
    }

    const handlePictureClick = () => {
        hiddenFileInput.current.click();
    };

    // useEffect(() => {
    //     focusTextarea();
    //     focusPhotoArea()
    // })

    // const focusTextarea = () => {
    //     if ( descriptionFocus ) {
    //         textareaRef.current.focus();
    //     }
    // }
    
    // const focusPhotoArea = () => {
    //     if ( photoError ) {
    //         photoRef.current.focus();
    //     }
    // }

    return (
        <div className={ styles.form_container }>
            <p className={ styles.title }>Información Personal</p>
            <div className={ styles.form_wrapper }>
                <div className={ styles.form_row} style={{marginBottom: '24px'}}>
                    <label>Nombres y apellidos como aparecen en tu identificación oficial.</label>
                </div>
                <div className={ styles.form_columns }>
                    <InputText
                        cssContainer={ styles.form_column }
                        name={ 'firstName' }
                        label={ 'Nombres*' }
                        value={ personalInfo.firstName || "" }
                        onChange={ onChangeInput }
                        onBlur={ onPersonalInfoBlur }
                        error={ Object.keys(personalInfoErrors).includes("firstName") ? personalInfoErrors.firstName[0] : '' }
                        marginError={ Object.keys(personalInfoErrors).includes("lastName") && !Object.keys(personalInfoErrors).includes("firstName") }
                    />
                    <InputText
                        cssContainer={ styles.form_column }
                        name={ 'lastName' }
                        label={ 'Apellidos*' }
                        value={ personalInfo.lastName || "" }
                        onChange={ onChangeInput }
                        onBlur={ onPersonalInfoBlur }
                        error={ Object.keys(personalInfoErrors).includes("lastName") ? personalInfoErrors.lastName[0] : '' }
                        marginError={ Object.keys(personalInfoErrors).includes("firstName") && !Object.keys(personalInfoErrors).includes("lastName") }
                    />
                </div>
                <div className={ styles.form_columns }>
                    <InputText
                        cssContainer={ styles.form_column }
                        name={ 'nss' }
                        label={ 'Número de seguro social*' }
                        value={ personalInfo.nss || "" }
                        maxLength={ 11 }
                        onChange={ onChangeInput }
                        onBlur={ onPersonalInfoBlur }
                        error={ Object.keys(personalInfoErrors).includes("nss") ? personalInfoErrors.nss[0] : '' }
                        marginError={ Object.keys(personalInfoErrors).includes("curp") && !Object.keys(personalInfoErrors).includes("nss") }
                    />
                    <InputText
                        cssContainer={ styles.form_column }
                        name={ 'curp' }
                        label={ 'CURP (opcional)' }
                        value={ personalInfo.curp || "" }
                        maxLength={ 18 }
                        onChange={ onChangeInput }
                        onBlur={ onPersonalInfoBlur }
                        error={ Object.keys(personalInfoErrors).includes("curp") ? personalInfoErrors.curp[0] : '' }
                        marginError={ Object.keys(personalInfoErrors).includes("nss") && !Object.keys(personalInfoErrors).includes("curp") }
                    />
                </div>
                <p className={ `${styles.form_section_title} ${styles.label_blue}` }>Contacto</p>
                <div className={ styles.form_columns }>
                    <InputText
                        cssContainer={ styles.form_column }
                        name={ 'email' }
                        label={ 'Correo electrónico de contacto*' }
                        value={ personalInfo.email || "" }
                        maxLength={ 100 }
                        onChange={ onChangeInput }
                        onBlur={ onPersonalInfoBlur }
                        error={ Object.keys(personalInfoErrors).includes("email") ? personalInfoErrors.email[0] : '' }
                        marginError={ Object.keys(personalInfoErrors).includes("phone") && !Object.keys(personalInfoErrors).includes("email") }
                    />
                    <InputText
                        cssContainer={ styles.form_column }
                        name={ 'phone' }
                        label={ 'Teléfono (10 dígitos)*' }
                        value={ personalInfo.phone || "" }
                        maxLength={ 10 }
                        onChange={ onChangeInput }
                        onBlur={ onPersonalInfoBlur }
                        error={ Object.keys(personalInfoErrors).includes("phone") ? personalInfoErrors.phone[0] : '' }
                        marginError={ Object.keys(personalInfoErrors).includes("email") && !Object.keys(personalInfoErrors).includes("phone") }
                    />
                </div>
                <p className={ `${styles.form_section_title} ${styles.label_blue}` }>Experiencia</p>
                <div className={ styles.form_row} style={{marginBottom: '12px'}}>
                    <label>Posición laboral a la que te estás postulando o última posición desempeñada*</label>
                </div>
                <div className={ styles.form_columns }>
                    <InputText
                        cssContainer={ styles.form_column }
                        name={ 'position' }
                        subLabel={ 'Ejemplos: Project Manager, Contador.' }
                        value={ personalInfo.position || "" }
                        onChange={ onChangeInput }
                        onBlur={ onPersonalInfoBlur }
                        error={ Object.keys(personalInfoErrors).includes("position") ? personalInfoErrors.position[0] : '' }
                    />
                </div>
                <div className={ styles.form_columns}>
                    <Seniority
                        name='jobSeniorityId'
                        label={ 'Nivel de experiencia*' }
                        catSeniority={ catSeniority }
                        value={ personalInfo.jobSeniorityId }
                        onChange={ onChangeInput }
                        onBlur={ onPersonalInfoBlur }
                        error={ Object.keys(personalInfoErrors).includes("jobSeniorityId") ? personalInfoErrors.jobSeniorityId[0] : '' }
                    />
                </div>
                {/* <div className={ styles.form_columns}>
                    <InputSelect
                        name='experienceInSectors'
                        cssContainer={ styles.form_row }
                        cssSubtitle={ styles.subtitle }
                        cssCounter={ styles.subtitle_left }
                        label={ 'Experiencia en sector (opcional)' }
                        sublabel={ 'Selecciona máximo 5 sectores donde tengas experiencia. ' }
                        counterLabel={ 'sectores' }
                        placeholder={ 'Escribe para buscar sectores' }
                        options={ catSector }
                        onChange={ onChangeInputSelect }
                    />
                </div> */}
                <div className={ styles.form_row}>
                    <TextArea
                        cssSubtitle={ styles.subtitle }
                        cssCounter={ styles.subtitle_left }
                        name={ 'description' }
                        label={ 'Acerca de ti*' }
                        sublabel={ 'Danos un breve resumen de tu formación académica, experiencia profesional, y competencias técnicas y personales que te identifican.' }
                        maxLength={ 1500 }
                        errorLen={ 'validator.length' }
                        value={ personalInfo.description || "" }
                        onChange={ onChangeInput }
                        onBlur={ onPersonalInfoBlur }
                        error={ Object.keys(personalInfoErrors).includes("description") ? personalInfoErrors.description[0] : '' }
                    />
                </div>
                <p className={ `${styles.form_section_title} ${styles.label_blue}` }>Fotografía*</p>
                <p><b>Debe ser una fotografía reciente, a color, con fondo liso y en la que uses vestimenta casual de negocios.</b></p>
                <label className={ styles.subtitle }>
                    El tamaño máximo de 10 MB y estar en cualquiera de los siguientes formatos: JPG, JPEG o PNG.
                </label>
                {
                    Object.keys(personalInfoErrors).includes("imgProfile") && (
                        <p className={ styles.error_message }>{ personalInfoErrors.imgProfile[0] }</p>
                    )
                }
                <div className={ styles.form_row }>
                    <div className={ styles.image_container + " " + (( Object.keys(personalInfoErrors).includes("imgProfile")) && styles.error) } onClick={handlePictureClick}>
                        <button ref={ photoRef }>
                            {
                                !file ? (
                                    personalInfo.imgProfile ? (
                                        <>
                                            <div className={ styles.image_circle }>
                                                <img src={ `${personalInfo.imgProfile}?${performance.now()}` } />
                                            </div>
                                            <div className={ styles.image_text }>
                                                <p>Editar foto de perfil</p>
                                                <img src={ pencilIcon } alt="" />
                                            </div>
                                        </>
                                    ) : (
                                        <img src={ profileIcon } alt="" />
                                    )
                                ) : (
                                    <>
                                        <div className={ styles.image_circle }>
                                            <img src={ URL.createObjectURL(file) } />
                                        </div>
                                        <div className={ styles.image_text }>
                                            <p>Editar foto de perfil</p>
                                            <img src={ pencilIcon } alt="" />
                                        </div>
                                    </>
                                )
                            }
                            
                        </button>
                    </div>
                    <input className={ styles.file_input } type="file" onChange={handleFileInputChange} ref={hiddenFileInput} accept="image/png, image/gif, image/jpeg" />
                </div>
                <p className={ `${styles.form_section_title} ${styles.label_blue}` }>Ubicaci&oacute;n</p>
                <div className={ styles.form_columns }>
                    <div className={ styles.form_column }>
                        <div className={ stylesM.custom_select }>
                            <label>Pa&iacute;s*</label>
                            <Select
                                name={ 'country' }
                                placeholder={ 'Selecciona un país' }
                                value={ personalInfo.country || selectEmtpy }
                                onChange={ onChangeSelect }
                                onBlur={ onPersonalInfoBlur }
                                options={ catCountries }
                                error= { Object.keys(personalInfoErrors).includes("country") ? personalInfoErrors.country[0] : '' }
                            />
                            {
                                Object.keys(personalInfoErrors).includes("country") && (
                                    <p className={ styles.error_message }>{ personalInfoErrors["country"][0] }</p>
                                )
                            }
                            { Object.keys(personalInfoErrors).includes("state") && !Object.keys(personalInfoErrors).includes("country") && '\u00A0' }
                        </div>
                    </div>
                    <InputText
                        cssContainer={ styles.form_column }
                        name={ 'state' }
                        label={ 'Estado/Región*' }
                        value={ personalInfo.state || "" }
                        onChange={ onChangeInput }
                        onBlur={ onPersonalInfoBlur }
                        error={ Object.keys(personalInfoErrors).includes("state") ? personalInfoErrors["state"][0] : '' }
                        marginError={ Object.keys(personalInfoErrors).includes("country") && !Object.keys(personalInfoErrors).includes("state") }
                    />
                </div>
                <p className={ `${styles.form_section_title} ${styles.label_blue}` }>Sueldo actual o &uacute;ltimo (neto)</p>
                <div className={ styles.form_columns }>
                    <div className={ styles.form_column }>
                        <label>Cantidad*</label>
                        <QuantityRange
                            name={{ range1: currentSalary }}
                            currencyFormat
                            value={{ range1: `${ personalInfo[currentSalary] || '' }` }}
                            onChange={ onChangeInput }
                            onBlur={ onPersonalInfoBlur }
                            error= { Object.keys(personalInfoErrors).includes("currentSalary") ? personalInfoErrors.currentSalary[0] : '' }
                        />
                    </div>
                    <div className={ styles.form_column }>
                        <div className={ stylesM.custom_select }>
                            <label>Moneda*</label>
                            <Select
                                name={ currentCurrency }
                                placeholder={ '' }
                                value={ personalInfo[currentCurrency] || selectEmtpy }
                                onChange={ onChangeSelect }
                                onBlur={ onPersonalInfoBlur }
                                options={ catCurrencies }
                                error= { Object.keys(personalInfoErrors).includes("currentCurrency") ? personalInfoErrors.currentCurrency[0] : '' }
                            />
                            {
                                Object.keys(personalInfoErrors).includes("currentCurrency") && (
                                    <p className={ styles.error_message }>{ personalInfoErrors["currentCurrency"][0] }</p>
                                )
                            }
                            { Object.keys(personalInfoErrors).includes("currentSalary") && '\u00A0' }
                        </div>
                    </div>
                </div>
                <p className={ `${styles.form_section_title} ${styles.label_blue}` }>Expectativa salarial neta</p>
                <div className={ styles.form_columns }>
                    <div className={ styles.form_column }>
                        <label>Cantidad*</label>
                        <QuantityRange
                            name={{ range1: salaryMin, range2: salaryMax }}
                            currencyFormat
                            currencySymbol={ '$' }
                            inputAlign={ 'right' }
                            label={{ range1: 'De', range2: 'a' }}
                            value={{
                                range1: `${ personalInfo[salaryMin] || '' }`,
                                range2: `${ personalInfo[salaryMax] || '' }`
                            }}
                            onChange={ onChangeInput }
                            onBlur={ onPersonalInfoBlur }
                            error= { Object.keys(personalInfoErrors).includes("salary") ? personalInfoErrors.salary[0] : '' }
                        />
                    </div>
                    <div className={ styles.form_column }>
                        <div className={ stylesM.custom_select }>
                            <label>Moneda*</label>
                            <Select
                                name={ currency }
                                placeholder={ '' }
                                value={ personalInfo[currency] || selectEmtpy }
                                onChange={ onChangeSelect }
                                onBlur={ onPersonalInfoBlur }
                                options={ catCurrencies }
                                error= { Object.keys(personalInfoErrors).includes("currency") ? personalInfoErrors.currency[0] : '' }
                            />
                            {
                                Object.keys(personalInfoErrors).includes("currency") && (
                                    <p className={ styles.error_message }>{ personalInfoErrors["currency"][0] }</p>
                                )
                            }
                            { Object.keys(personalInfoErrors).includes("salary") && '\u00A0' }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PersonalInfo;